<template>
  <div class="contract-stock-dialog">
    <el-dialog v-drag-dialog :title="model.title" :visible.sync="visible" :before-close="closeDialog" :close-on-click-modal="false" width="1080px">
      <div class="dialog-body">
        <!-- 表单 -->
        <el-form :model="form" ref="form">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('crm_gift_part_scheme_dialog.chan_pin_xing_hao')" prop="productCode" :rules="rules.productCode">
                <custom-select url="productCodeSelectList" v-model="form.productCode" :props="{ label: 'productCode', value: 'productCode' }" width="100%" @change="onChangeProduct"></custom-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('crm_gift_part_scheme_dialog.fang_an_bian_hao')" prop="ruleCode" :rules="rules.ruleCode">
                <el-input placeholder="" clearable v-model="form.ruleCode"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('crm_gift_part_scheme_dialog.she_bei_lei_xing')" prop="deviceBizTypes" :rules="rules.deviceBizTypes">
                <el-checkbox-group v-model="form.deviceBizTypes">
                  <el-checkbox v-for="item in deviceBizTypesList" :key="item.value" :label="item.value"></el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('Common.com_status')" prop="state" :rules="rules.state">
                <el-radio-group v-model="form.state">
                  <el-radio :label="1">{{ $t('Common.com_enable') }}</el-radio>
                  <el-radio :label="0">{{ $t('Common.com_disable') }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 赠送条件 -->
          <el-row :gutter="20">
            <el-form-item :label="$t('crm_gift_part_scheme_dialog.zeng_song_tiao_jian')" class="form-must form-label-left">
              <div style="margin: 32px 0 10px; padding: 22px 10px 16px; border: 1px solid #dedede">
                <div>
                  <el-radio-group v-model="form.connectSymbol" style="padding: 0 8px; margin-bottom: 12px">
                    <el-radio :label="1">{{ $t('crm_gift_part_scheme_dialog.ren_yi_tiao_jian') }}</el-radio>
                    <el-radio :label="2">{{ $t('crm_gift_part_scheme_dialog.suo_you_tiao_jian') }}</el-radio>
                  </el-radio-group>
                </div>
                <div class="ub" style="padding: 0 8px; margin-bottom: 12px" v-for="(item, index) in ruleConditionList" :key="index">
                  <div style="margin-right: 4px; color: #a1a1a1">（</div>
                  <div class="ub-f3" style="margin-right: 6px">
                    <custom-select
                      :ref="'rule' + index"
                      code="giveaway_rule_variable"
                      v-model="item.type"
                      width="100%"
                      :model="item"
                      :props="{ label: 'name', value: 'value', map: { name: 'typeName' } }"
                    ></custom-select>
                  </div>
                  <!-- 添加初始运算 开始-->
                  <div class="ub-f3">
                    <div class="ub">
                      <div class="ub-f2" style="margin-right: 12px" v-if="item.isInitialOperator">
                        <custom-select code="isynergy_cloud_operator" v-model="item.initialOperator" width="100%"></custom-select>
                      </div>
                      <div class="ub-f2" style="margin-right: 6px" v-if="item.isInitialOperator">
                        <el-input type="number" v-input.intp v-model="item.initialNum" style="width: 100%"></el-input>
                      </div>
                      <div class="ub-f4" v-if="!item.isInitialOperator" style="margin-right: 6px">
                        <el-button style="width: 100%" @click="item.isInitialOperator = true">{{ $t('crm_gift_part_scheme_dialog.tian_jia_yun_suan') }}</el-button>
                      </div>
                    </div>
                  </div>
                  <div style="margin-right: 12px; color: #a1a1a1">)</div>
                  <!-- 添加初始运算 结束-->
                  <!-- 添加运算 开始-->
                  <div class="ub-f2" style="margin-right: 12px" v-if="item.isOperator">
                    <custom-select code="isynergy_cloud_operator" v-model="item.operator" width="100%"></custom-select>
                  </div>
                  <div class="ub-f2" style="margin-right: 12px" v-if="item.isOperator">
                    <el-input type="number" v-input.intp v-model="item.num" style="width: 100%"></el-input>
                  </div>
                  <div class="ub-f4" v-if="!item.isOperator" style="margin-right: 18px; margin-left: 6px">
                    <el-button style="width: 100%" @click="item.isOperator = true">{{ $t('crm_gift_part_scheme_dialog.tian_jia_yun_suan') }}</el-button>
                  </div>
                  <!-- 添加运算 结束-->
                  <div style="width: 100px; margin-right: 12px">
                    <custom-select code="isynergy_cloud_symbol" v-model="item.symbol" width="100%"></custom-select>
                  </div>
                  <div class="ub-f2" style="margin-right: 12px; position: relative">
                    <el-input type="number" v-model="item.value" style="width: 100%"></el-input>
                  </div>
                  <el-button v-if="index == 0" type="primary" @click="addSymbol(ruleConditionList)">
                    <i class="icon icon-add"></i>
                    {{ $t('Common.com_added') }}
                  </el-button>
                  <el-button v-else type="warning" @click="delSymbol(ruleConditionList, index)">
                    <i class="icon icon-shanchu"></i>
                    {{ $t('Common.com_delete') }}
                  </el-button>
                </div>
              </div>
            </el-form-item>
          </el-row>
          <!-- 赠送配件 -->
          <el-row :gutter="20">
            <el-form-item :label="$t('crm_gift_part_scheme_dialog.zeng_song_pei_jian')" class="form-must form-label-left">
              <el-table :data="goodsList">
                <el-table-column type="index" label="#"></el-table-column>
                <el-table-column min-width="60" :label="$t('crm_gift_part_scheme_dialog.ling_jian_ming_cheng')">
                  <template slot-scope="scope">
                    <custom-select
                      url="smsGoodsSelectList"
                      :listener="`${form.productCode}`"
                      v-model="scope.row.goodsSkuId"
                      :model="scope.row"
                      :dataFilter="dataFilter"
                      :props="{ label: 'erpGoodsName', value: 'goodsSkuId', map: { goodsName: 'goodsName', unit: 'unit', erpCode: 'erpCode', speclist: 'goodsSpec' } }"
                      :params="{ productCode: form.productCode }"
                      :placeholder="$t('Common.com_please_select')"
                      width="100%"
                    ></custom-select>
                  </template>
                </el-table-column>
                <el-table-column min-width="40" :label="$t('crm_gift_part_scheme_dialog.ling_jian_shu_liang')">
                  <template slot-scope="scope">
                    <el-input type="number" v-input.intp placeholder="" v-model="scope.row.bookingNum"></el-input>
                  </template>
                </el-table-column>
                <el-table-column min-width="40" :label="$t('crm_gift_part_scheme_dialog.yun_xu_geng_huan')">
                  <template slot-scope="scope">
                    <el-radio-group v-model="scope.row.isReplace" @change="onChangePart(scope.row)">
                      <el-radio :label="1">{{ $t('Common.com_yes') }}</el-radio>
                      <el-radio :label="0">{{ $t('Common.com_no') }}</el-radio>
                    </el-radio-group>
                  </template>
                </el-table-column>
                <el-table-column min-width="60" :label="$t('crm_gift_part_scheme_dialog.geng_huan_ling_jian')">
                  <template slot-scope="scope">
                    <custom-select
                      multiple
                      :disabled="!scope.row.isReplace"
                      url="smsGoodsSelectList"
                      :listener="`${form.productCode}`"
                      v-model="scope.row.childGoodsSkuId"
                      :model="scope.row"
                      :dataFilter="dataFilter"
                      :props="{ label: 'erpGoodsName', value: 'goodsSkuId' }"
                      :params="{ productCode: form.productCode }"
                      :placeholder="$t('Common.com_please_select')"
                      width="100%"
                    ></custom-select>
                  </template>
                </el-table-column>
                <el-table-column min-width="40" :label="$t('Common.com_handle')">
                  <template slot-scope="scope">
                    <span></span>
                    <el-button v-if="scope.$index == 0" size="mini" type="primary" @click="addGoods(goodsList)">
                      <!-- <i class="icon icon-add"></i> -->
                      {{ $t('Common.com_added') }}
                    </el-button>
                    <el-button v-else type="warning" size="mini" @click="delGoods(goodsList, scope.$index)">
                      <!-- <i class="icon icon-shanchu"></i> -->
                      {{ $t('Common.com_delete') }}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="primary" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  props: {
    data: [String, Object, Array],
  },
  data() {
    return {
      disableChange: true, // 解决初始就出发下拉选择的change事件
      // 赠送配件
      goodsList: [
        {
          goodsName: '',
          goodsSkuId: '',
          erpCode: '',
          unit: '',
          isReplace: 0,
          bookingNum: 1,
          childGoodsSkuId: [],
          childGoodsList: [],
        },
      ],
      ruleConditionList: [
        {
          type: '',
          typeName: '',
          operator: '',
          initialOperator: '',
          value: '',
          symbol: '',
          num: '',
          initialNum: '',
          isInitialOperator: false,
          isOperator: false,
        },
      ],
      form: {
        goodsList: [],
        productCode: '',
        deviceBizTypes: [],
        ruleCode: '',
        ruleCondition: '',
        ruleDesc: '',
        ruleExpression: '', // 存储编辑解析(前端用)
        state: 1,
        triggerMethod: 1,
        connectSymbol: 1,
      },
      deviceBizTypesList: [],
    };
  },
  computed: {
    rules() {
      return {
        ruleCode: [
          { required: true, message: this.$t('crm_gift_part_scheme_dialog.qtxfabm') },
          { max: 30, message: this.$t('Common.com_rules_length_max', [30]) },
        ],
        deviceBizTypes: [{ required: true, message: this.$t('crm_gift_part_scheme_dialog.qxzsblx') }],
        productCode: [{ required: true, message: this.$t('crm_gift_part_scheme_dialog.qxzcpxh') }],
        state: [{ required: true, message: this.$t('crm_gift_part_scheme_dialog.qxzcpxh') }],
        triggerMethod: [{ required: true, message: this.$t('crm_gift_part_scheme_dialog.qxzcpxh') }],
      };
    },
  },
  mounted() {
    this.initDialog();
    this.getDictionary('dms_device_biz_type', (data) => {
      this.deviceBizTypesList = data.dms_device_biz_type;
    });
  },
  methods: {
    dataFilter: function (list) {
      return list.map((t) => ({ ...t, erpGoodsName: `${t.erpCode}/${t.goodsName}` }));
    },
    onChangePart: function (row) {
      if (!row.isReplace) {
        row.childGoodsSkuId = [];
        row.childGoodsList = [];
        row.multiple = [];
      }
    },
    // 更改产品型号
    onChangeProduct: function () {
      if (this.disableChange) {
        return;
      }
      this.goodsList = [
        {
          goodsName: '',
          goodsSkuId: '',
          erpCode: '',
          unit: '',
          isReplace: 0,
          bookingNum: 1,
          childGoodsSkuId: [],
          childGoodsList: [],
        },
      ];
    },
    // 添加配件
    addGoods: function (item) {
      item.push({
        goodsName: '',
        goodsSkuId: '',
        erpCode: '',
        unit: '',
        isReplace: 0,
        bookingNum: 1,
        childGoodsSkuId: [],
        childGoodsList: [],
        multiple: [],
      });
    },
    // 删除配件
    delGoods: function (item, index) {
      item.splice(index, 1);
    },
    // 添加条件
    addSymbol: function (item) {
      item.push({
        type: '',
        typeName: '',
        operator: '',
        initialOperator: '',
        num: '',
        initialNum: '',
        symbol: '',
        value: '',
        isInitialOperator: false,
        isOperator: false,
      });
    },
    // 删除条件
    delSymbol: function (item, index) {
      item.splice(index, 1);
    },
    // 初始化
    initDialog: function () {
      if (this.model.type === 'edit') {
        const arr = this.model.data.deviceBizTypes ? this.model.data.deviceBizTypes.split(',') : [];
        const target = Object.assign({}, this.model.data, { deviceBizTypes: arr });
        this.$setFormatData(this.form, target);
        this.getRuleGoodsList(this.model.data);
        this.ruleConditionList = this.jsonRuleExpression(this.form.ruleExpression, true);
      }
    },
    // 获取赠送配件
    getRuleGoodsList(row) {
      this.$getJSON(`${apis.giveawayRuleInfoGoods}/${row.giveawayRuleId}`).then((res) => {
        const list = res.data || [];
        list.forEach((item) => {
          const childList = item.childList || [];
          item.childGoodsSkuId = childList.map((t) => t.goodsSkuId);
          item.childGoodsList = childList;
          item.multiple = childList;
        });
        this.goodsList = list;
        setTimeout(() => {
          this.disableChange = false;
        }, 3000);
      });
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    // 确认保存
    confirm: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.model.type === 'add') {
          this.saveInsert();
        }
        if (this.model.type === 'edit') {
          this.saveUpdate();
        }
      });
    },
    // 格式化规则
    formatRuleConditionList: function (list, isDesc) {
      const arr = [];
      list.forEach((t) => {
        let str = '';
        // 初始运算符
        if (t.isInitialOperator && t.initialOperator && t.initialNum) {
          if (isDesc) {
            str = `(${t.typeName}${t.initialOperator}${t.initialNum})`;
          } else {
            str = t.initialOperator === '/' ? `Math.floor(${t.type}${t.initialOperator}${t.initialNum})` : `(${t.type}${t.initialOperator}${t.initialNum})`;
          }
        } else {
          str = isDesc ? t.typeName : t.type;
        }
        // 添加运算符
        if (t.operator && t.operator && t.num) {
          if (isDesc) {
            str = `${str}${t.operator}${t.num}`;
          } else {
            str = t.operator === '/' ? `Math.floor(${str}${t.operator}${t.num})` : `${str}${t.operator}${t.num}`;
          }
        }
        // 最终运算
        str = `${str}${t.symbol}${t.value}`;
        arr.push(str);
      });
      return arr.join(this.form.connectSymbol === 1 ? '||' : '&&');
    },
    // 存储解析规则
    jsonRuleExpression: function (target, isParse) {
      let result = '';
      const tag = this.form.connectSymbol === 1 ? '||' : '&&';
      if (isParse) {
        if (target) {
          const arr = target.split(tag);
          result = arr.map((t) => {
            const item = t.split(',') || [];
            return {
              type: item[0],
              initialOperator: item[1],
              initialNum: item[2],
              operator: item[3],
              num: item[4],
              symbol: item[5],
              value: item[6],
              isInitialOperator: item[1] && item[2],
              isOperator: item[3] && item[4],
            };
          });
        }
      } else {
        if (target && target.length) {
          result = target.map((t) => `${t.type},${t.initialOperator},${t.initialNum},${t.operator},${t.num},${t.symbol},${t.value}`).join(tag);
        }
      }
      return result;
    },
    // 保存新增
    saveInsert: function () {
      const list = this.ruleConditionList.filter((t) => t.type && t.symbol && t.value);
      if (list.length) {
        this.form.ruleCondition = this.formatRuleConditionList(list);
        this.form.ruleDesc = this.formatRuleConditionList(list, true);
      } else {
        this.form.ruleCondition = '';
      }
      this.form.ruleExpression = this.jsonRuleExpression(list);
      const list2 = this.goodsList.filter((t) => t.goodsSkuId && t.bookingNum && (!t.isReplace || (t.childGoodsSkuId && t.childGoodsSkuId.length)));
      if (list2.length) {
        this.form.goodsList = this.goodsList.map((t) => {
          if (t.multiple) {
            t.multiple.forEach((item) => {
              item.isReplace = t.isReplace;
              item.bookingNum = 0;
            });
          }
          return Object.assign(t, { childGoodsList: t.multiple || [] });
        });
      } else {
        this.form.goodsList = [];
      }
      if (!this.form.ruleCondition) {
        this.$message.error(this.$t('crm_gift_part_scheme_dialog.zstjbnwk'));
        return;
      }
      if (!this.form.goodsList.length) {
        this.$message.error(this.$t('crm_gift_part_scheme_dialog.zspjbnwk'));
        return;
      }
      const form = Object.assign({}, this.form, { deviceBizTypes: this.form.deviceBizTypes.join(',') });
      this.$postJSON(apis.giveawayRuleAdd, form).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.$emit('success');
        this.closeDialog();
      });
    },
    // 保存编辑
    saveUpdate: function () {
      const list = this.ruleConditionList.filter((t) => t.type && t.symbol && t.value);
      if (list.length) {
        this.form.ruleCondition = this.formatRuleConditionList(list);
        // 编辑赋值不会触发change所以有可能没有字典name，需要主动触发
        this.ruleConditionList.forEach((item, index) => {
          const ref = this.$refs[`rule${index}`];
          ref[0].onChange();
        });
        this.form.ruleDesc = this.formatRuleConditionList(list, true);
      } else {
        this.form.ruleCondition = '';
      }
      this.form.ruleExpression = this.jsonRuleExpression(list);
      const list2 = this.goodsList.filter((t) => t.goodsSkuId && t.bookingNum && (!t.isReplace || (t.childGoodsSkuId && t.childGoodsSkuId.length)));
      if (list2.length) {
        this.form.goodsList = this.goodsList.map((t) => {
          t.multiple.forEach((item) => {
            item.isReplace = t.isReplace;
            item.bookingNum = 0;
          });
          return Object.assign(t, { childGoodsList: t.multiple });
        });
      } else {
        this.form.goodsList = [];
      }
      if (!this.form.ruleCondition) {
        this.$message.error(this.$t('crm_gift_part_scheme_dialog.zstjbnwk'));
        return;
      }
      if (!this.form.goodsList.length) {
        this.$message.error(this.$t('crm_gift_part_scheme_dialog.zspjbnwk'));
        return;
      }
      const form = Object.assign({}, this.form, { deviceBizTypes: this.form.deviceBizTypes.join(',') });
      this.$postJSON(`${apis.giveawayRuleUpdate}/${this.model.data.giveawayRuleId}`, form).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.$emit('success', this.form);
        this.closeDialog();
      });
    },
  },
};
</script>

<style lang="scss">
.contract-stock-dialog {
  .form-label-left .el-form-item__label {
    padding-left: 12px !important;
  }
  .unit {
    .el-form-item__label {
      opacity: 0;
    }
  }
}
</style>
